import { useEffect, useRef } from 'react';
import { PAGE_LOADER_WEB_CONTAINER_ID, PAGE_LOADER_WEB_SENTENCE_ID } from './PageLoaderElement.contants';
import { hidePageLoader } from './PageLoaderElement.utils.web';

export const PageLoaderElement = ({
  sentences,
  showSentence = false,
}: {
  sentences: string[];
  showSentence?: boolean;
}) => {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const pageLoaderContainer = document.getElementById(PAGE_LOADER_WEB_CONTAINER_ID);
    const sentenceSpan = document.getElementById(PAGE_LOADER_WEB_SENTENCE_ID);
    if (pageLoaderContainer) {
      pageLoaderContainer.style.display = 'flex';
      if (sentenceSpan) {
        sentenceSpan.innerText = sentences[0];
        if (showSentence) {
          let index = 0;
          intervalRef.current = setInterval(() => {
            index += 1;
            if (!!sentences[index]) {
              if (sentenceSpan) {
                sentenceSpan.innerText = sentences[index];
              }
            }
          }, 5000);
        }
      }
    }

    return () => {
      hidePageLoader();
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  return <></>;
};
